import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchSettings } from "../lib/api";

const DEFAULTS = {
  brand_name: "Adi / Notes",
  hero_image: "",
  hero_top_left: "Vol. 01 — Edition MMXXVI",
  hero_top_right: "Hyderabad · India",
  blog_posts_label: "Blog Posts",
  about_label: "About",
  about_heading: "Capital, growth, & the messy in between.",
  about_body: "",
  subscribe_label: "Get every new article →",
  contact_email: "contact@naielkhatri.com",
  hide_contact_email: false,
  social_linkedin: "#",
  social_newsletter: "#",
  social_instagram: "#",
  social_twitter: "#",
  social_biolink: "#",
  hide_social_linkedin: false,
  hide_social_newsletter: false,
  hide_social_instagram: false,
  hide_social_twitter: false,
  hide_social_biolink: false,
  // Blog Posts (Index) page
  index_heading: "The Index.",
  index_subtitle: "Blog posts on venture, growth, and the operator mindset.",
  index_empty_title: "No blog posts yet",
  index_empty_body:
    "The first post is being written. Subscribe to be notified when it lands.",
  // About Me page
  about_hero_image: "",
  about_hero_left: "Profile",
  about_hero_right: "Long form",
  about_me_heading: "The story behind the notes.",
  about_me_body: "",
  about_floating_image: "",
  // Author block (bottom of every blog post)
  author_name: "Naiel Khatri",
  author_image: "",
  author_bio: "Notes from the intersection of capital, growth, and entrepreneurship.",
  author_linkedin: "",
  author_label: "Author",
  // Community / newsletter block (bottom of each blog post)
  community_enabled: true,
  community_image: "",
  community_title: "Boardroom Notes | VC Lens",
  community_tagline:
    "Behind-the-scenes VC insights, founder game, and real lessons from the boardroom. No fluff. Just strategy.",
  community_social_avatar: "",
  community_social_text: "1,049 connections are subscribed",
  community_subscriber_text: "1,168 subscribers",
  community_cta_url: "",
  community_cta_label: "Subscribe on LinkedIn",
};

const STORAGE_KEY = "blog_settings_cache_v1";

const readCache = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const writeCache = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // ignore quota / storage errors
  }
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  // Initialise from localStorage cache → instant render with last-known content,
  // even while the backend is waking from a Render cold start.
  const [settings, setSettings] = useState(() => {
    const cached = readCache();
    return cached ? { ...DEFAULTS, ...cached } : DEFAULTS;
  });

  const refresh = useCallback(async () => {
    try {
      const data = await fetchSettings();
      const merged = { ...DEFAULTS, ...data };
      setSettings(merged);
      writeCache(data);
    } catch (e) {
      // Backend unavailable — keep cached/default values so the site still renders
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
